export default {"src":"/_next/static/media/lightGrid.cf90e8f7.svg","height":722,"width":632,"blurWidth":0,"blurHeight":0};